import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CurrencyInput } from '../../utilComponents/inputs/CurrencyInput';
import { CustomSelectInput } from '../../utilComponents/inputs/CustomSelectInput';
import { validateInput } from '../../../helpers/validateInput';

export const SalesValueStep = ({ form, handleUpdateForm }) => {
    const [touchedFields, setTouchedFields] = useState({});

    const validateField = (name, value) => {
        return validateInput(name, value, form);
    };

    const handleFieldChange = (field, value) => {
        handleUpdateForm(field, value);
        setTouchedFields({ ...touchedFields, [field]: true });
    };

    return (
        <Box mb={4}>
            <Typography variant="h6" sx={{ marginBottom: '10px' }}>
                Paso 4: Valor de Venta y Motivo de No Compra
            </Typography>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                }}
            >
                <CurrencyInput
                    label="Valor de Venta"
                    value={form.saleValue}
                    onChange={formattedValue =>
                        handleFieldChange('saleValue', formattedValue)
                    }
                    error={
                        touchedFields.saleValue &&
                        !!validateField('saleValue', form.saleValue)
                    }
                    helperText={
                        touchedFields.saleValue &&
                        validateField('saleValue', form.saleValue)
                    }
                />

                <CustomSelectInput
                    label="Motivo de No Compra"
                    value={form.reasonNoPurchase}
                    onChange={e =>
                        handleFieldChange('reasonNoPurchase', e.target.value)
                    }
                    error={
                        touchedFields.reasonNoPurchase &&
                        !!validateField(
                            'reasonNoPurchase',
                            form.reasonNoPurchase
                        )
                    }
                    helperText={
                        touchedFields.reasonNoPurchase &&
                        validateField('reasonNoPurchase', form.reasonNoPurchase)
                    }
                    options={[
                        { value: 'PRI', label: 'PRECIO' },
                        { value: 'TDE', label: 'TIEMPO DE ENTREGA' },
                        { value: 'CAL', label: 'CALIDAD' },
                        { value: 'SER', label: 'SERVICIO' },
                        { value: 'NPR', label: 'NO. PRENDAS' },
                        { value: 'CCP', label: 'CUENTA CON PROVEEDOR' },
                        { value: 'OTR', label: 'OTROS' },
                    ]}
                />
            </div>
        </Box>
    );
};
